import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'eta',
})
export class EtaPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {Date | string} value
   * @returns {string}
   */
  transform(value: Date | string): string {
    const eta = moment().diff(moment(value).format('YYYY-MM-DD'), 'year');
    return eta === 1 ? `${eta} anno` : `${eta} anni`;
  }
}
